export default class uploadImagesArea {
    constructor() {
        return {
            restrict: 'E',
            controller: ['$scope', '$timeout', '$element', '$attrs', ($scope, $timeout, $element, $attrs) => {
                var dropArea = $element[0];
                var inputFile = $element.find(':file');

                inputFile.bind('change', (changeEvent) => {
                    if (changeEvent.target.files.length > 0) {
                        $scope.$emit('imageBank:uploadImages', { files: changeEvent.target.files });
                    }
                });

                $scope.fileNameChanged = function (input) {
                    $scope.$emit('imageBank:uploadImages', { files: input.files });
                };

                $(dropArea).bind('dragover', (e) => {
                    e.preventDefault();

                    $timeout(() => {
                        var eventName = $attrs.type == 'event' ? 'event:image:dragover' : 'imageBank:dragOver';
                        $scope.$emit(eventName);
                    });
                });

                $(dropArea).bind('dragleave', (e) => {
                    e.preventDefault();

                    $timeout(() => {
                        var eventName = $attrs.type == 'event' ? 'event:image:dragleave' : 'imageBank:dragLeave';
                        $scope.$emit(eventName);
                    });
                });

                dropArea.addEventListener('drop', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if ($attrs.type == 'event') {
                        var droppedImage = $(e.dataTransfer.getData('text/html')).filter('img')[0];
                        $('#contentImage, .image-layover').attr('src', $(droppedImage).attr('src'));
                    } else if (e.dataTransfer && e.dataTransfer.files.length) {
                        $scope.$emit('imageBank:uploadImages', { files: e.dataTransfer.files });
                    }

                    $timeout(() => {
                        var eventName = $attrs.type == 'event' ? 'event:image:drop' : 'imageBank:dragLeave';
                        $scope.$emit(eventName);
                    }, 100);
                });
            }]
        }
    }
};
